import { Component } from '@angular/core';
import { BaseListComponent } from "../base/base-list.component";

@Component({
    selector: 'curso-prestacao-conta',
    templateUrl: './curso-prestacao-conta.component.html',
})
export class CursoPrestacaoContaComponent extends BaseListComponent {
    controllerName = 'turma';
    filtro = this.formBuilder.group({
        query: [null],
        id_curso: [null]
    });

    filtroTurma = this.formBuilder.group({
        id_curso: [null]
    });

    dataDia: Date = new Date();

    curso: any = null;
    listaTurma: any[] = [];
    idCurso: number = null;
    linkTipoListar: string;
    namePrestarConta: string;
    nameEditar: string;
    query: any;
    nameVisualizar: string;
    algo: any;

    init() {

        if (sessionStorage.getItem("msg") != null) {
            this.showMsgSucess(sessionStorage.getItem("msg"))
            sessionStorage.removeItem("msg");
        }

        this.listagem.pDatatableComponent.sortOrder = 2;
        var listaLink = location.href.split("/");
        this.linkTipoListar = listaLink[6];
        this.idCurso = +listaLink[7];
        this.filtroTurma.get('id_curso').setValue(this.idCurso);
        if (this.linkTipoListar === 'listar-turma') {
            this.namePrestarConta = 'turma_prestar_conta';
            this.nameEditar = "turma_editar";
            this.nameVisualizar = 'turma_visualizar';
        } else {
            this.namePrestarConta = 'turma_prestar_conta_homologacao';
            this.nameEditar = "turma_editar_homologacao";
            this.nameVisualizar = 'turma_visualizar_homologacao';
        }


        if (sessionStorage.getItem('turma_edicao') == this.router.url.split('/')[2]) {
            this.query = sessionStorage.getItem('filtro_turma_edicao');
            this.algo = this.query.split('&')
                .map(str => {
                    let [key, value] = str.split('=');
                    return { [key]: decodeURI(value) };
                })
                .reduce((prev, curr) => Object.assign(prev, curr));
            Object.keys(this.algo).forEach(key => {
                this.algo[key] = this.algo[key].split('%2C').length > 1 ? this.algo[key].split('%2C') : this.algo[key];
                if (!Array.isArray(this.algo[key])) {
                    this.algo[key] = this.algo[key].split('+').length > 1 ? this.concatStringFiltro(this.algo[key].split('+')) : this.algo[key];
                }
                this.algo[key] = this.algo[key] == "null" ? null : this.algo[key];
            });
            this.filtro.patchValue(this.algo);
            this.carregarEstadoPaginacao();
        } else if (sessionStorage.getItem('funcionalidade') != 'gerenciamento-curso' && sessionStorage.getItem('funcionalidade') != 'homologacao-curso') {
            sessionStorage.removeItem('funcionalidade');
            sessionStorage.removeItem('filtro');
            sessionStorage.removeItem('pagina');
        }

    }

    urlturma (route: string, appendController: boolean = true, filter: any = null): string{
        let params: URLSearchParams = new URLSearchParams();

        filter = Object.assign({}, filter, { id_lotacao: localStorage.getItem('lotacao') ? localStorage.getItem('lotacao') : '' });
        if (filter != null) {
            Object.keys(filter).map(k => params.set(k, filter[k]));
        }


        return appendController ? `${this.baseUrl}/${this.controllerName}/${route}?${params.toString()}` : `${this.baseUrl}/${route}?${params.toString()}`;
    }

    voltar(event: any) {
        if (this.linkTipoListar === 'listar-turma') {
            this.router.navigate(['/atividades/gerenciamento-curso'], { relativeTo: this.activatedRoute });
        } else {
            this.router.navigate(['/atividades/homologacao-curso'], { relativeTo: this.activatedRoute });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/curso-prestacao-conta/curso-prestacao-conta.component.ts